import { RootState } from 'src/config/Store';
import { FetchStatus } from 'src/models/Chat';

// if you want to change anything in this selector make the same change in membersSelectors.ts
export const getConversations = (state: RootState) => Object.values(state.chat.conversations);

export const getNewMatchConversations = (state: RootState) =>
  Object.values(state.chat.conversations).filter(
    (conversation) => conversation.isNewMatch || conversation.isMatchedOverFiveDaysAgo,
  );

export const getConversationsWithMessages = (state: RootState) =>
  Object.values(state.chat.conversations).filter(
    (conversation) =>
      conversation.active &&
      conversation.newestMessage &&
      !conversation.isNewMatch &&
      !conversation.isMatchedOverFiveDaysAgo,
  );

export const getFetchStatus = (state: RootState) => state.chat.fetchStatus;
export const getPageInfo = (state: RootState) => state.chat.pageInfo;

export const getActiveConversation = (state: RootState) => {
  if (state.chat.currentConversation) {
    return state.chat.conversations[state.chat.currentConversation];
  }

  return null;
};

export const getActiveConversationUuid = (state: RootState) => state.chat.currentConversation;

export const getMessages = (state: RootState) => Object.values(state.chat.messages);

export const getMessagesFetchStatus = (state: RootState) => state.chat.messagesFetchStatus;

export const canLoadMoreMessages = (state: RootState) => {
  const lastLoadedMessage = state.chat.messagesPageInfo.lastMessageUuid;

  return (
    lastLoadedMessage &&
    state.chat.messagesFetchStatus === FetchStatus.Completed &&
    lastLoadedMessage !== state.chat.messagesPageInfo.oldestMessageUuid
  );
};

export const getIsSearching = (state: RootState) => Boolean(state.chat.search);

export const getUnreadConversationUuids = (state: RootState) => state.chat.unreadConversations;
export const getHasUnread = (state: RootState) => !!getUnreadConversationUuids(state).length;

export const getActiveConversationTopicsOfFocus = (state: RootState) => {
  if (state.chat.memberTopicsOfFocus) {
    return state.chat.memberTopicsOfFocus;
  }

  return null;
};
